export default "__VITE_ASSET__D8GftAgo__"